import { FC } from 'react';

import ArrowBackIcon from '@/public/icons/arrow-back.svg';
import ArrowForwardIcon from '@/public/icons/arrow-forward.svg';
import { useTranslation } from 'next-i18next';

interface ArrowProps {
  onClick?: () => void;
  disabled?: boolean;
}
export const PrevArrow: FC<ArrowProps> = ({ onClick, disabled }) => {
  const { t } = useTranslation('common');
  return (
    <button
      aria-label={`${t('prevArrow')}`}
      disabled={disabled}
      className="dark:gray-scale-red-border dark: dark:gray-scale-red flex h-12 w-12 items-center justify-center rounded-full border border-accentMain p-4 text-accentMain transition-colors duration-300 hover:bg-accentMain hover:text-white focus:bg-accentMain focus:text-white"
      onClick={() => !disabled && onClick?.()}
    >
      <ArrowBackIcon width={24} height={24} />
    </button>
  );
};

export const NextArrow: FC<ArrowProps> = ({ onClick, disabled }) => {
  const { t } = useTranslation('common');
  return (
    <button
      aria-label={`${t('nextArrow')}`}
      className="dark:gray-scale-red-border dark: dark:gray-scale-red flex h-12 w-12 items-center justify-center rounded-full border border-accentMain p-4 text-accentMain transition-colors duration-300 hover:bg-accentMain hover:text-white focus:bg-accentMain focus:text-white"
      onClick={() => !disabled && onClick?.()}
      disabled={disabled}
    >
      <ArrowForwardIcon width={24} height={24} />
    </button>
  );
};
